module.exports = __webpack_public_path__ + "static/media/calendar-with-clock-24.3571e1b7.svg";